import React from 'react';
import Grid from '@mui/material/Grid';
import { colors } from "../../../../styles/customStyles";

const TermsFooter = ({ isXs }) => {
  const linkStyle = {
    color: colors.darkgrey,
    marginRight: '5px',
    marginLeft: '5px',
    fontSize: 10,
    textAlign: isXs ? 'center' : 'right',
    marginBottom: 0,
    paddingBottom: 0,
    lineHeight: 'normal',
    display: 'inline-block',
  };

  const containerStyle = {
    alignItems: isXs ? 'center' : 'flex-end',
    zIndex: 5,
    position: 'relative',
    justifyContent: isXs ? 'center' : 'flex-end',
    paddingBottom: '2.5%',
    width: '100%',
    textAlign: isXs ? 'center' : 'left',
    paddingRight: '1%',
  };

  return (
    <div style={containerStyle}>
      <Grid
        container
        direction="row"
        style={{
          width: '100%',
          alignItems: isXs ? 'center' : 'flex-end',
          justifyContent: isXs ? 'center' : 'flex-end',
        }}
      >
        <Grid item>
          <a href="/privacy-policy" style={{ textDecoration: 'none' }}>
            <p style={linkStyle}>Privacy Policy</p>
          </a>
        </Grid>

        <Grid item><p style={linkStyle}>{'\u2022'}</p></Grid>

        <Grid item>
          <a href="/terms" style={{ textDecoration: 'none' }}>
            <p style={linkStyle}>Terms & Conditions</p>
          </a>
        </Grid>

        <Grid item><p style={linkStyle}>{'\u2022'}</p></Grid>

        <Grid item>
          <a href="/cookie-policy" style={{ textDecoration: 'none' }}>
            <p style={linkStyle}>Cookie Policy</p>
          </a>
        </Grid>

        <Grid item><p style={linkStyle}>{'\u2022'}</p></Grid>

        <Grid item>
          <a href="mailto:hello@innerreefapp.com" style={{ textDecoration: 'none' }}>
            <p style={linkStyle}>hello@innerreefapp.com</p>
          </a>
        </Grid>

        <Grid item>
          <p style={linkStyle}>
            Copyright © Inner Reef {new Date().getFullYear()}. All Rights Reserved.
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default TermsFooter;
